import { render, staticRenderFns } from "./PhoneList.vue?vue&type=template&id=3e1dfb84"
import script from "./PhoneList.vue?vue&type=script&lang=js"
export * from "./PhoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports